module.exports = __WEBPACK_EXTERNAL_MODULE__1347__;